import { render } from "./Chatbot.vue?vue&type=template&id=13e64c81"
import script from "./Chatbot.vue?vue&type=script&lang=js"
export * from "./Chatbot.vue?vue&type=script&lang=js"

import "@/css/chatbot.scss?vue&type=style&index=0&lang=scss"
import "./Chatbot.vue?vue&type=style&index=1&id=13e64c81&lang=css"

import exportComponent from "/Users/pnz002/Project/dfy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__